const styles = theme => ({
  fetchPersonDetailsContainer: {
    gridColumn: '1 / 4',
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gridTemplateRows: 'auto',
  },
  fetchBtnContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: '28px',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      '& button': {
        width: '100%',
      },
    },
  },
  occupantCardActionButton: {
    cursor: 'pointer',
    fontSize: '20px',
    fontWeight: '500',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      gap: 5,
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 'auto',
      },
    },
    '& button': {
      textTransform: 'none',
      minWidth: 40,
      maxHeight: 40,
      padding: '0px',
      '& path': {
        stroke: 'black',
      },
      [theme.breakpoints.down('sm')]: {
        minHeight: 40,
      },
    },

    '& :hover': {
      '& path': {
        stroke: theme.palette.primary.main,
      },
    },

    display: 'flex',
    flexDirection: ' column',
  },
  premiseWrapper: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  getRepDetailsBtnContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    '& button': {
      height: 'max-content',
      flex: 1,
    },
  },
  representativeDetailsInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 30,
  },
  representativeDetailsCardTitle: {
    fontSize: 18,
    fontWeight: 600,
  },
  representativeDetailsCard: {
    padding: 16,
    border: `1px solid ${theme.palette.primary.borderColor}`,
    backgroundColor: theme.palette.primary.white,
  },
  subleasePermissionTitle: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '16px',
  },
  subleasePermissionContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: 16,
    border: `1px solid ${theme.palette.primary.borderColor}`,
    backgroundColor: theme.palette.primary.white,
  },
  premiseAddressContainer: {
    padding: '8px 0 16px 0',
  },
  fetchAllUnitsBtn: {
    '&:disabled': {
      background: '#EBEEF3',
    },
    textTransform: 'none',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
      minWidth: '100px !important',
      padding: '7px 10px !important',
      borderRadius: '0px !important',
    },
  },
  toggleIcon: {
    marginLeft: '5px',
  },
  textTransformNone: {
    textTransform: 'none',
  },
  readMoreLink: {
    textTransform: 'lowercase',
    '& > span': {
      display: 'inline-block',
      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
    background: 'transparent !important',
    color: `${theme.palette.primary.adgmSkyBlue}`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  fetchDetailsBtn: {
    padding: '8px 20px',
    borderRadius: '0px',
    border: '1px solid #0D2A3A',
    background: 'transparent !important',
    '& span': {
      textTransform: 'capitalize',
      color: '#0D2A3A',
    },
  },
  fetchDetailsBtnAr: {
    padding: '8px 16px',
    borderRadius: '0px',
    '& span': {
      textTransform: 'capitalize',
    },
  },
  amenitiesCheckbox: {
    '& svg': {
      height: '20px !important',
      width: '20px !important',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'space-between',
      flexDirection: 'row-reverse',
      margin: '0px auto',
    },
  },
  adewaRadioContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  marginTopOnSm: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '16px',
    },
  },
  label: {
    marginBottom: '4px',
    fontWeight: 500,
    fontSize: '12px',
    color: '#2F3239 !important',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '16px',
    },
  },
  agreementDetailsBlock: {
    '& p': {
      fontSize: '16px',
      color: '#130F26',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: '599px',
    },
  },
  agreementMessage: {
    fontSize: '14px',
    color: '#6C7281',
    position: 'relative',
    top: '5px',
  },
  textADGMRed: {
    color: theme.palette.primary.errorRed,
    fontSize: '20px',
  },
  bottomMargin: {
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      '&.MuiFormGroup-row': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
  UnitsComponents: {
    display: 'flex',
    gap: '30px',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      padding: '16px 0px',
    },
  },
  dateField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '0px !important',
    },
  },

  selectStyle: {
    [theme.breakpoints.down('sm')]: {
      bottom: '50px',
    },
  },
  onwaniSelect: {
    '& span:last-child': {
      // color: theme.palette.primary.adgmBlack,
    },
    fontSize: '16px',
  },
  onwaniContainer2: {
    [theme.breakpoints.up('sm')]: {
      width: '442px',
    },
  },
  selectBox: {
    width: '442px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '14px !important',
      '& p': {
        fontSize: '14px !important',
      },
    },
  },
  subTitleInfo: {
    [theme.breakpoints.down('xs')]: {
      display: 'inline-block',
    },
  },
  location2: {
    color: '#8C9099',
    display: 'flex',
  },
  location: {
    color: '#8C9099',
    textDecoration: 'none',
    display: 'block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: '5px',
    '& img': {
      marginRight: '5px',
      display: 'inline-block !important',
      maxWidth: '12px',
    },
  },
  CheckboxHolder: {
    '& label': {
      '& span': {
        fontSize: '14px',
      },
    },
    '& input:checked + svg': {
      color: '#342D3D',
    },
    '& input:checked + div': {
      color: '#342D3D',
    },
  },
  CheckboxHolder2: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column !imortant',
      '&.MuiFormGroup-root': {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column !important',
      },
      '& label': {
        display: 'inline-flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginRight: '0px',
        marginLeft: '0px',
      },
    },
    '& label': {
      '& span': {
        fontSize: '14px',
      },
    },
    '& input:checked + svg': {
      color: '#342D3D',
    },
    '& input:checked + div': {
      color: '#342D3D',
    },
  },
  premiseContentMobile: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
      paddingBottom: '16px',
    },
  },
  premiseContentMobile2: {
    [theme.breakpoints.down('sm')]: {
      borderTop: '1px solid #EBEEF3',
      marginTop: '16px',
      paddingTop: '16px',
    },
  },
  paperCardFrame: {
    marginBottom: '24px',
    borderRadius: '0px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0px',
      border: 'none',
    },
  },
  paperTypeBlock: {
    marginBottom: '24px',
    borderRadius: '0px',
    border: 'none',
    boxShadow: 'none !important',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0px',
      border: 'none',
    },
  },
  title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '16px',
  },
  innerCard2: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    position: 'relative',
    borderRadius: '0px',
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      margin: '0px',
    },
  },
  innerCardGridRemovePadding: {
    [theme.breakpoints.down('sm')]: {
      padding: '0px !important',
    },
  },
  innerCardGrid: {
    width: '100%',
    padding: '16px',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gridTemplateRows: 'auto',
    columnGap: '16px',
    rowGap: '16px',
    alignItems: 'start',
    position: 'relative',
  },
  gridFullWidth: {
    gridColumn: '1 / 3',
    marginTop: '-16px',
    [theme.breakpoints.down('sm')]: {
      borderBottom: '1px solid #EBEEF3',
    },
  },
  gridFullWidth2: {
    gridColumn: '1 /  2',
  },
  blurryInnerGrid: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    background: theme.palette.primary.white,
    opacity: 0.4,
    zIndex: 1,
  },

  blurryADGMSelect: {
    background: theme.palette.primary.white,
    opacity: 0.4,
    zIndex: 1,
  },
  removeBackground: {
    background: 'none',
  },
  disabledFieldsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    padding: '12px 0px',
    paddingRight: '-100px',
    columnGap: '10px',
    borderBottom: '1px solid #EBEEF3',
    '& > $fieldWithInfo': {
      '& > div:last-child': {
        marginTop: '10px',
      },
    },
  },
  fieldWithInfo: {},
  titleHead: {
    color: '#342D3D',
    display: 'block',
    alignItems: 'center',
    padding: '16px 0px',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      borderBottom: '0px solid #CED1D6',
      display: 'flex',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      fontWeight: '600',
      // '& span': {
      //   // color: theme.palette.primary.main,
      // },
    },
    '& $textGray': {
      color: theme.palette.primary.darkGrey,
      fontSize: '14px',
      alignSelf: 'flex-end',
    },
    '& $title1': {
      fontSize: '20px',
      fontWeight: '600',
    },
  },

  titleBlock: {
    color: '#342D3D',
    padding: '16px 0px',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      borderBottom: '0px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '18px',
      fontWeight: '600',
    },
    '& p': {
      color: '#8C9099',
      fontSize: '16px',
      fontWeight: '500',
    },
  },
  titleHeadAccordian: {
    background: 'transparent',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '0px',
    justifyContent: 'space-between',
    // [theme.breakpoints.up('sm')]: {
    //   borderBottom: '1px solid #CED1D6',
    // },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '18px',
      fontWeight: '600',
      // '& span': {
      //   // color: theme.palette.primary.main,
      // },
    },
    '& $textGray': {
      color: theme.palette.primary.darkGrey,
      fontSize: '14px',
      alignSelf: 'flex-end',
    },
    '& $title1': {
      fontSize: '20px',
      fontWeight: '600',
    },
    [theme.breakpoints.down('sm')]: {
      '& h1': {
        marginBottom: '0',
        marginRight: '8px',
        fontSize: '16px',
        fontWeight: '600',
      },
      padding: '0px 16px 0px 16px',
    },
  },
  mobilePropertyReview: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    '& img': {
      height: '72px',
      width: '72px',
    },
  },
  unitRegContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& p': {
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '21px',
    },
  },
  unitRegNumber: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '& img': {
      height: '24px !important',
      width: '48px !important',
    },
    '& p': {
      fontSize: '18px',
      fontWeight: '600',
      lineHeight: '27px',
    },
  },
  titleHead2: {
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '16px 0px 17px 0px',
    justifyContent: 'space-between',
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '18px',
      fontWeight: '600',
      // '& span': {
      //   // color: theme.palette.primary.main,
      // },
    },
    '& $textGray': {
      color: theme.palette.primary.darkGrey,
      fontSize: '14px',
      alignSelf: 'flex-end',
    },
    '& $title1': {
      fontSize: '20px',
      fontWeight: '600',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
      '& h1': {
        marginBottom: '0',
        marginRight: '8px',
        fontSize: '14px',
        fontWeight: '600',
      },
    },
  },
  lightWeightLable: {
    color: '#565960 !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    lineHeight: '21px !important',
    [theme.breakpoints.down('sm')]: {
      fontWeight: '400 !important',
      fontSize: '12px !important',
      lineHeight: '18px !important',
    },
  },
  lightWeightValue: {
    fontWeight: '600 !important',
    fontSize: '16px !important',
    lineHeight: '24px !important',
    [theme.breakpoints.down('sm')]: {
      fontWeight: '500 !important',
      fontSize: '12px !important',
      lineHeight: '18px !important',
    },
  },
  slightBlackColor: {
    color: '#342D3D !important',
  },
  title1: {},
  fontColor: {
    color: theme.palette.primary.darkGrey + '!important',
  },
  subTitle: {
    fontSize: '16px',
    fontWeight: '500',
    color: theme.palette.primary.darkGrey + '!important',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      fontWeight: '500',
    },
  },
  subTitle1: {
    color: theme.palette.primary.errorRed + '!important',
    fontSize: '20px',
    fontWeight: 100,
  },
  adgmSelect: {
    height: '56px',
  },
  uploader: {
    '& img': {
      height: '14px !important',
      width: '14px !important',
    },
  },
  initiateserviceSect: {
    borderBottom: '1px solid #EBEEF3',
    marginBottom: '16px',
    fontSize: '12px',
    '& p': {
      fontSize: '12px',
    },
    '& $Title': {
      fontSize: '14px',
    },
    '&:last-child': {
      borderBottom: '0',
      marginBottom: '0',
    },
    '& $link': {
      fontSize: '12px',
    },
  },
  textGrayLight: {
    color: theme.palette.primary.darkGrey,
  },
  link: {
    textDecoration: 'none',
  },
  initiateservicedtaile: {
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: '9px',
    '& img': {
      display: 'none',
    },
  },
  occuEmail: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
    },
  },
  occuName: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingBottom: '16px',
      borderBottom: '1px solid #EBEEF3',
    },
  },
  occupant2: {
    display: 'flex',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
      paddingBottom: '16px',
    },
  },
  occupant3: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
    },
  },

  occupantDetails2: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 0px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      padding: '16px 0px',
      '&:not(:last-of-type)': {
        marginBottom: '16px',
        borderBottom: '1px solid #EBEEF3',
      },
    },
  },

  propertyImage: {
    width: '100%',
    height: '100%',
  },
  horizontalRadio: {
    flexDirection: 'row',
    color: theme.palette.secondary.light,
    '& input:checked + div': {
      color: theme.palette.primary.main,
    },
    '& input:disabled + div': {
      color: '#CED1D6',
    },
    '& svg': {
      height: '20px',
      width: '20px',
    },
    '& span': {
      fontSize: '14px',
      // color: "#130F26 !important",
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& .MuiFormControlLabel-root': {
        flexDirection: 'row-reverse',
        justifyContent: ' space-between',
        marginLeft: '0px',
        marginRight: '0px',
        width: '100% !important',
      },
      '& svg': {
        height: '24px',
        width: '24px',
      },
      '& span': {
        fontSize: '16px',
        fontWeight: '400',
      },
    },
  },
  radio: {
    marginRight: '40px',
  },
  staticList: {
    borderTop: '1px solid #EBEEF3',
    paddingTop: '25px',
    marginTop: '20px',
    '& $staticListLabel': {
      color: theme.palette.primary.dim,
      marginBottom: '15px',
    },
    '& $staticListItemHolder': {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr) )',
      color: '#342D3D',
      '& svg': {
        marginRight: '8px',
      },
    },
  },
  staticListItemHolder: {},
  staticListLabel: {},
  fetchDetailsControl: {
    display: 'grid',
    gridTemplateColumns: 'auto 151px',
    gap: '8px',
    alignItems: 'flex-end',
    marginBottom: '8px',
    '& button': {
      background: '#342D3D',
      borderRadius: '0px',
      height: '53px',
      minWidth: '151px',
    },
  },
  premiseContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto 151px',
    columnGap: '16px',
    marginBottom: '6px',
    alignItems: 'end',
    // alignItems: 'center',
    '& > button': {
      color: '#000',
      background: '#fff',
      padding: '1em',
      height: '56px',
      borderRadius: '0px',
      textTransform: 'Capitalize',
      fontSize: '16px',
      border: '1px solid #0D2A3A',
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.primary.adgmHover,
        color: theme.palette.primary.white,
        border: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        height: '48px',
        columnGap: '8px',
        fontSize: '14px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      columnGap: '8px',
    },
  },
  premiseContainer2: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    columnGap: '16px',
    marginBottom: '16px',
    alignItems: 'end',
    // alignItems: 'center',
    '& > button': {
      background: '#130F26',
      padding: '1em',
      height: '56px',
      borderRadius: '0px',
      textTransform: 'none',
      [theme.breakpoints.down('sm')]: {
        height: '48px',
        columnGap: '8px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateColumns: 'auto',
      columnGap: '8px',
      rowGap: '16px',
      marginBottom: '16px',
    },
  },
  premiseContainer2Multi: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    columnGap: '16px',
    marginBottom: '16px',
    alignItems: 'center',
    '& button': {
      background: '#130F26',
      padding: '1em',
      height: '56px',
      width: '125px',
      borderRadius: '0px',
      textTransform: 'none',
      marginTop: '8px',
      fontSize: '16px',
      [theme.breakpoints.down('sm')]: {
        marginTop: '0px',
        marginBottom: '16px',
        height: '52px',
        columnGap: '8px',
        width: '87px',
        fontSize: '14px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      columnGap: '8px',
      rowGap: '16px',
      marginBottom: '16px',
    },
  },
  premiseContainerMulti: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '16px',
    marginBottom: '16px',
    // alignItems: 'center',
    '& button': {
      background: '#130F26',
      padding: '1em',
      height: '56px',
      width: '125px',
      borderRadius: '0px',
      textTransform: 'none',
      fontSize: '16px',
      [theme.breakpoints.down('sm')]: {
        height: '48px',
        columnGap: '8px',
        width: '87px',
        fontSize: '14px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateColumns: 'auto',
      columnGap: '8px',
      rowGap: '16px',
      marginBottom: '16px',
    },
  },
  premiseFullWidth: {
    gridTemplateColumns: 'auto',
  },
  informationMessage: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '18px',
    color: '#6C7281',
    paddingBottom: '16px',
    marginBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '8px',
      marginBottom: '8px',
      width: '60%',
    },
  },
  informationMessage2: {
    paddingBottom: '16px',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '18px',
    color: '#6C7281',
    [theme.breakpoints.down('sm')]: {
      width: '60%',
    },
  },
  informationMessageOccupant: {
    paddingTop: '4px',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '18px',
    color: '#6C7281',
  },
  informationMessage3: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '21px',
    color: '#6C7281',
    // paddingBottom: "16px",
    // borderBottom: "1px solid #EBEEF3",
    marginBottom: '16px',
  },
  informationMessageNoBorder: {
    borderBottom: 'none',
    marginBottom: '0px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  premiseAddressField: {
    // minHeight: "60px",
    '& > p': {
      fontSize: '12px',
    },
    '& h6': {
      fontSize: '12px',
    },
  },
  tenantDetails_fieldFlex: {
    marginTop: '8px',
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      width: '48%',
    },
    '& > span': {
      width: '4%',
    },
  },
  occupantsInfo: {
    color: '#190B28',
    borderBottom: '1px solid #EBEEF3',
    '& h6': {
      color: theme.palette.primary.dim,
      fontSize: '12px',
    },
    '& p': {
      fontSize: '12px',
    },
    '& $gridItem': {
      padding: '0 15px 10px',
      '&:last-child': {
        border: '0',
      },
    },
    '& $gridItems2': {
      padding: '24px',
      [theme.breakpoints.down('sm')]: {
        padding: '0px 24px',
      },
      '&:last-child': {
        border: '0',
      },
    },
    '&:last-child': {
      // marginBottom: '20px',
    },
    '& button': {
      padding: '0',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '24px 0 16px 0px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
  },
  gridItem: {
    [theme.breakpoints.down('sm')]: {
      borderBottom: '1px solid #EBEEF3',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
  gridItems2: {},
  griditem: {
    [theme.breakpoints.down('sm')]: {
      borderBottom: '1px solid #EBEEF3',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
  lessorContainer: {
    padding: '24px',
  },
  boxPadding: {
    padding: '12px',
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
      borderBottom: '1px solid #EBEEF3',
    },
  },
  flexCenter2: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  ownerAvatarimg: {
    height: '64px',
    width: '64px',
    background: '#EBEEF3',
    // marginInlineEnd: ".5rem",
    [theme.breakpoints.down('sm')]: {
      height: '40px',
      width: '40px',
      marginInlineEnd: '0rem',
    },
  },
  removeBtn: {
    '&:hover': {
      background: 'none !important',
    },
    cursor: 'pointer',
    fontSize: '20px',
    fontWeight: '500',
    justifyContent: 'center',
    // color: theme.palette.primary.darkGrey,
    '& button': {
      // color: theme.palette.primary.darkGrey,
      textTransform: 'none',
      minWidth: '20px',
    },
    '& img': {
      // marginInlineEnd: '5px',
      width: '40px',
      height: '40px',

      [theme.breakpoints.down('sm')]: {
        width: '20px',
        marginLeft: 'auto',
      },
    },
    display: 'flex',
    flexDirection: ' column',
    // alignItems: 'end',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
    },
  },
  remove: {
    '&:hover': {
      border: 'none !important',
      background: 'none !important',
    },
    '&:focusVisible': {
      border: 'none !important',
      background: 'none !important',
    },
  },
  removeBtnMulti: {
    '&:hover': {
      background: 'none !important',
    },
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    '& p': {
      fontSize: '14px',
      fontWeight: '600',
      color: '#DF2C2C !important',
    },
    // color: theme.palette.primary.darkGrey,
    '& button': {
      // color: theme.palette.primary.darkGrey,
      textTransform: 'none',
      minWidth: '14px',
      [theme.breakpoints.down('sm')]: {
        height: 40,
        width: 40,
      },
    },
    '& img': {
      marginInlineEnd: '5px',
      // width: '14px',
      [theme.breakpoints.down('sm')]: {
        width: '40px',
        marginLeft: 'auto',
      },
    },
    display: 'flex',
    flexDirection: ' column',
    alignItems: 'end',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
      gap: 5,
    },
  },
  addOccpantsBtnHolder: {
    marginTop: '30px',
  },
  addOccpantsBtn: {
    height: '48px',
    minWidth: '229px',
    fontSize: '16px',
    fontWeight: '600',
    textTransform: 'none',
    border: '1.36111px solid #342D3D',
    borderRadius: '0px',
    '& p': {
      fontWeight: '600 !important',
    },
    '& svg': {
      marginRight: '8px',
      width: '16px',
    },
    '&:hover': {
      border: 'none',
      background: theme.palette.primary.main,
      color: theme.palette.primary.white,
      '& svg path': {
        fill: theme.palette.primary.white,
        stroke: theme.palette.primary.white,
      },
    },

    [theme.breakpoints.down('sm')]: {
      height: '48px',
      minWidth: '358px',
      fontSize: '16px',
      borderRadius: '0px',
      '& svg': {
        marginRight: '8px',
        width: '16px',
      },
    },
  },
  addOccpantsBtn2: {
    height: '56px',
    minWidth: '244px',
    fontSize: '16px',
    fontWeight: '600',
    textTransform: 'none',
    border: '1.36111px solid #342D3D',
    borderRadius: '0px',
    '& p': {
      fontWeight: '600 !important',
    },
    '& svg': {
      marginRight: '8px',
      width: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '48px',
      minWidth: '100%',
      fontSize: '16px',
      borderRadius: '0px',
      '& svg': {
        marginRight: '8px',
        width: '16px',
      },
    },
  },
  occpantsNextUnitBtn: {
    height: '56px',
    minWidth: '244px',
    fontSize: '16px',
    fontWeight: '600',
    textTransform: 'none',
    border: '1.36111px solid #342D3D',
    borderRadius: '0px',
    background: '#FFFFFF',
    '&:disabled': {
      border: 'none',
    },
    '& p': {
      fontWeight: '600 !important',
    },
    '& svg': {
      marginRight: '8px',
      width: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '48px',
      minWidth: '100%',
      fontSize: '16px',
      borderRadius: '0px',
      '& svg': {
        marginRight: '8px',
        width: '16px',
      },
    },
  },
  addOccpantsBtnMulti: {
    height: '32px',
    minWidth: '153px',
    '& span': {
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '21px',
    },
    lineHeight: '21px',
    textTransform: 'none',
    border: '1px solid #130F26',
    borderRadius: '0px',

    '& img': {
      marginRight: '8px',
      width: '14px',
      height: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '21px',
      minWidth: '160px',
      border: 'none',
      '& span': {
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '21px',
      },
      borderRadius: '0px',
      '& img': {
        marginRight: '6px',
        width: '12px !important',
        height: '12px',
      },
    },
  },
  addTermBtn: {
    height: '48px',
    fontSize: '16px',
    fontWeight: '600',
    textTransform: 'none',
    border: '1.36111px solid #342D3D',
    borderRadius: '0px',
    '& p': {
      fontSize: '16px',
      fontWeight: '600',
    },
    '& svg': {
      marginRight: '4px',
      width: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '48px',
      minWidth: '358px',
      fontSize: '16px',
      borderRadius: '0px',
      '& svg': {
        marginRight: '8px',
        width: '16px',
      },
    },
  },
  addAppendixImg: {
    marginInlineEnd: '8px',
  },
  modalpaper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
    borderRadius: '0px',
    fontSize: '16px',
  },
  modal: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '747px',
    position: 'relative',
    '& $Title': {
      marginBottom: '32px',
    },
    '& $crossIconimg': {
      position: 'absolute',
      right: '24px',
      top: '31px',
    },
    '& $modaltitlehead': {
      display: 'block',
      marginBottom: '8px',
      padding: '24px 24px 0px',
      '& img': {
        display: 'none',
      },
    },
  },
  occupantModal: {
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      margin: '0px auto',
    },
  },
  modaltitlehead: {},
  crossIconimg: {
    cursor: 'pointer',
  },
  formControl: {
    marginBottom: '16px',
    width: '100%',
    display: 'grid',
    gap: '16px',
    gridTemplateColumns: '1fr',
  },
  formControlfullwidth: {
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
    },
  },
  formControlfullwidth2: {
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px',
    },
  },
  tenantPhoneField: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '16px',
    },
  },
  submitBtnholder: {
    textAlign: 'right',
    padding: '16px',
    marginTop: '1.5rem',
    borderTop: '3px solid #EBEEF3',
    '& button:first-of-type': {
      marginInlineEnd: '1rem',
    },
  },
  submitBtnholder2: {
    textAlign: 'right',
    padding: '16px',
    marginTop: '1.5rem',
    borderTop: '3px solid #EBEEF3',
    [theme.breakpoints.down('sm')]: {
      '& button:first-of-type': {
        marginInlineEnd: '1rem',
      },
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  submitBtn: {
    background: theme.palette.primary.main,
    // background: '#D2374F',
    fontSize: '16px',
    color: '#fff',
    height: '60px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '0px',
  },
  submitBtnOccupant: {
    background: theme.palette.primary.main,
    // background: '#D2374F',
    fontSize: '16px',
    color: '#fff',
    height: '56px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '0px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '48px',
    },
  },
  cancelBtnOccupant: {
    background: '#FFFFFF',
    border: '1.36111px solid #342D3D',
    fontSize: '16px',
    height: '56px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '0px',
    [theme.breakpoints.down('sm')]: {
      height: '48px',
    },
  },
  calendarTextfieldIcon: {
    marginRight: '0px',
    cursor: 'pointer',
  },
  infoAttribute: {
    color: '#6C7281',
    padding: 0,
    marginTop: '6px',
  },
  infoAttribute2: {
    color: '#6C7281',
  },
  infoPanel: {
    marginBottom: '16px',
    fontWeight: 500,
    color: theme.palette.primary.adgmBlack,
  },
  attributeCheckbox: {
    marginTop: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
    borderTop: '1px solid #EBEEF3',
    '& .MuiFormControlLabel-label': {
      fontWeight: 500,
      fontSize: '16px',
    },
  },
  attributeCheckboxDescription: {
    position: 'relative',
    maxWidth: '100%',
    fontSize: '12px',
    lineHeight: '1.8',
    padding: '10px',
    marginLeft: '34px',
    borderRadius: '0px 10px 10px 10px',
    color: theme.palette.primary.darkGrey,
    border: '1px solid #CED1D6',
    '&::before': {
      position: 'absolute',
      content: '""',
      height: '10px',
      width: '10px',
      background: '#fff',
      left: '-1px',
      top: '-10px',
      borderStyle: 'solid',
      borderWidth: '10px 0 0 10px',
      borderColor: 'transparent transparent transparent #CED1D6',
    },
    '& > img': {
      marginRight: '6px',
    },
  },
  largeButton2: {
    height: '40px',
    minWidth: '121px',
    fontSize: '12px',
    fontWeight: '500 !important',
    textTransform: 'none',
    border: '1px solid #342D3D',
    borderRadius: '0px',
    padding: '8px 16px !important',
    '& img': {
      marginRight: '4px',
      width: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '334px',
      fontSize: '14px',
    },
    '&:hover': {
      '& img': {
        filter: 'invert(1)',
      },
      backgroundColor: theme.palette.primary.adgmHover,
      color: theme.palette.primary.white,
      border: 'none',
    },
  },
  appendixTextAreaContainer: {
    '& > p': {
      display: 'block',
      marginBottom: '9px',
      fontWeight: 500,
      '& span': {
        // color: '#D2374F',
        fontSize: '18px',
      },
    },
  },
  appendixTextArea: {
    width: '100%',
    padding: '17px 16px',
    borderRadius: '0px',
    border: '1px solid #CED1D6',
    fontWeight: 300,
    '&:focus-visible': {
      outline: 'none',
      borderColor: theme.palette.primary.darkGrey,
    },
  },
  appendixDetailItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '20px 0px',
    '& p': {
      fontSize: '12px',
    },
    '& img': {
      marginRight: '12px',
    },
    '& button': {
      marginLeft: 'auto',
      color: theme.palette.primary.darkGrey,
      textTransform: 'none',
      flexShrink: '0',
      fontSize: '12px',
    },
    '& $btnHolder': {
      marginLeft: 'auto',
      '& > span': {
        color: theme.palette.primary.darkGrey,
      },
    },
    '& $removeLink': {
      marginLeft: 'auto',
      color: '#8C9099',
      flexShrink: '0',
      border: 'none',
      background: 'none',
    },
  },
  appendixDetailItemReview: {
    display: 'flex',
    alignItems: 'center',
    padding: '32px 0',
    borderBottom: '1px solid #EBEEF3',
    marginBottom: '32px',
    '&:first-child': {
      padding: '0 0 32px',
    },
    '&:last-child': {
      marginBottom: '0',
      borderBottom: 'none',
    },
    '& img': {
      marginRight: '17px',
    },
    '& $removeLink': {
      marginLeft: 'auto',
      color: '#8C9099',
      flexShrink: '0',
      paddingLeft: '7px',
    },
  },
  removeLink: {
    marginLeft: 'auto',
    color: '#8C9099',
    flexShrink: '0',
    border: 'none',
    background: 'none',
  },
  fileContainer: {
    // borderTop: "1px solid #EBEEF3",
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0px 0px 0px',
    '& p': {
      fontSize: '12px',
    },
    '& img': {
      // marginRight: "8px",
    },
    '& button': {
      marginLeft: 'auto',
      textTransform: 'none',
      color: 'grey',
      flexShrink: '0',
      fontSize: '12px',
    },
    '& $btnHolder': {
      marginLeft: 'auto',
      '& > span': {
        color: theme.palette.primary.darkGrey,
      },
    },
  },
  fileContainer2: {
    // borderTop: "1px solid #EBEEF3",
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0px 0px 0px',
    '& p': {
      fontSize: '14px',
    },
    '& img': {
      // marginRight: "8px",
    },
    '& button': {
      marginLeft: 'auto',
      textTransform: 'none',
      color: 'grey',
      flexShrink: '0',
      fontSize: '12px',
    },
    '& $btnHolder': {
      marginLeft: 'auto',
      '& > span': {
        color: theme.palette.primary.darkGrey,
      },
    },
  },
  btnHolder: {},
  lastFile: {
    // borderBottom: "1px solid #EBEEF3",
    // marginBottom: "20px",
  },
  lastFile2: {},
  accordianFrame: {
    [theme.breakpoints.up('md')]: {
      border: '0px solid #CED1D6',
      borderRadius: '0px',
    },
    margin: ' 0 0 5px !important',
    // overflow: "hidden",
    color: '#342D3D',
    '&:before': {
      background: 'transparent',
      display: 'none',
    },
  },
  expandedaccordianFrame: {
    [theme.breakpoints.up('md')]: {
      borderRadius: '0px !important',
    },
  },
  propertyAndRent: {
    padding: '16px',
    border: '1px solid #D5D6D7',
  },
  reviewBlock: {
    background: theme.palette.primary.white,
  },
  accordionDetails2: {
    padding: '24px 24px 0px 24px',
  },
  textAr: {
    fontFamily: '"madani", sans-serif',
    lineHeight: '18px',
  },
  detailsText: {
    fontSize: '18px',
    fontWeight: '600 !important',
  },
  accTitleHead: {
    background: '#F8F8F8',
    color: '#342D3D',

    '& > div': {
      margin: '0 !important',
    },
    '& $heading': {
      fontSize: '16px',
      fontWeight: '600',
      [theme.breakpoints.down('sm')]: {
        padding: '16px',
      },
    },
    '& svg': {
      color: '#342D3D',
      fontSize: '27px',
    },
  },
  heading: {},

  viewBtn: {
    // width: "32px !important",
    border: '1px solid #130F26',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '21px',
    textAlign: 'center',
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
  },
  uploadIcon: {
    transition: 'all .3s ease',
  },
  boxBackground: {
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
  },
  occupantsGridsect: {
    color: theme.palette.primary.dim,
    '& h6': {
      color: theme.palette.primary.acscent,
      fontWeight: '500',
    },

    // "& $griditem": {
    //   borderLeft: "1px solid #EBEEF3",
    //   padding: "12px 30px",
    //   "&:first-child": {
    //     border: "0",
    //   },
    // },
  },
  // occupantsGridsect: {
  //   "& h6": {
  //     fontSize: "12px",
  //   },
  //   "& p": {
  //     fontSize: "12px",
  //   },
  //   "& $griditem": {
  //     borderLeft: "0",
  //     borderTop: "1px solid #EBEEF3",
  //   },
  // },
  occupantName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    'line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    fontSize: '14px !important',
  },
  occupantModalFlex: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gridTemplateRows: 'auto',
    columnGap: '16px',
    rowGap: '16px',
  },
  griditem2: {
    display: 'flex',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
      borderBottom: '1px solid #EBEEF3',
    },
  },
  occupantsReview: {
    color: theme.palette.primary.dim,
    '& h6': {
      color: theme.palette.primary.acscent,
      fontWeight: '500',
    },
    '& $occupantsReviewRow': {
      borderBottom: '1px solid #EBEEF3',
      '&:last-child': {
        border: '0',
      },
      '& $griditem': {
        padding: '0.5em 0px',
      },
    },
  },
  lessorItems: {
    [theme.breakpoints.down('sm')]: {
      '& div': {
        borderBottom: '1px solid #EBEEF3',
      },
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
  occupantsReviewRow: {},
  uploadedDocuments: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    '& $fileWrapper': {
      padding: '24px',
    },
  },
  fileWrapper: {
    '& $accordianTitle': {
      padding: '0',
    },
  },
  fileWrapper2: {
    padding: '16px',
    background: '#F9F6F2',
    '& $accordianTitle': {
      padding: '0',
    },
  },
  calculatedField: {
    '& .MuiOutlinedInput-root': {
      background: theme.palette.primary.borderColor,
    },
  },
  checkboxContainer: {
    '& .MuiFormControlLabel-label': {
      fontSize: '16px',
      color: theme.palette.primary.adgmBlack,
    },
  },
  checkbox: {
    // color: theme.palette.primary.lightADGMGreen,
    color: '#130F26',
  },
  checked: {
    color: `${theme.palette.primary.main} !important`,
  },
  noPadding: {
    padding: '0px !important',
  },
  ownerListContainer: {
    '& $ownerListItem': {
      padding: '24px',
      borderBottom: '1px solid #EBEEF3',
      background: '#F9F6F2',
      display: 'flex',
      gap: '24px',
      [theme.breakpoints.down('sm')]: {
        padding: '8px 16px 8px 16px',
        '& .MuiListItemAvatar-root': {
          minWidth: '40px',
        },
      },
      '&:last-child': {
        borderBottom: 'none',
      },

      '& $avatar': {
        width: '64px',
        height: '64px',
        marginRight: '12px',
        [theme.breakpoints.down('sm')]: {
          width: '40px',
          height: '40px',
          marginRight: '8px',
        },
      },
      '& p': {
        fontSize: '16px',
        fontWeight: 600,
        color: theme.palette.primary.adgmBlack,
        [theme.breakpoints.down('sm')]: {
          fontSize: '12px',
          fontWeight: '500',
          lineHeight: '18px',
        },
      },
      '& $ownerCount': {
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '21px',
        color: theme.palette.primary.dim,
        [theme.breakpoints.down('sm')]: {
          fontSize: '12px',
          fontWeight: '400',
          lineHeight: '18px',
        },
      },
      '& .MuiListItemIcon-root': {
        minWidth: '20px',
      },
      '& $icon': {
        fontSize: '20px',
        [theme.breakpoints.down('sm')]: {
          fontSize: '24px',
        },
      },
      '& $iconChecked': {
        fontSize: '20px',
        [theme.breakpoints.down('sm')]: {
          fontSize: '24px',
        },
        color: '#0D2A3A',
      },
    },
  },
  buttonAddTerms: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  ownerListItem: {},
  ownerCount: {},
  avatar: {},
  icon: {},
  iconChecked: {},
  // style info Msg
  infoMsg: {
    marginInlineStart: '1.5rem',
    position: 'relative',

    '&::before': {
      content: '""',
      position: 'absolute',
      width: '18px',
      height: '10px',
      border: '1px solid #CED1D6',
      top: '0.9px',
      left: '4px',
      clipPath: 'polygon(0 0, 0% 100%, 100% 100%)',
      borderRadius: '0 0 0 4px',
      background: 'white',
      transform: 'rotate(88deg) skewX(145deg)',
    },
    '& $content': {
      minHeight: '38px',
      border: '1px solid #CED1D6',
      borderRadius: '0px',
    },
    '& img': {
      marginInlineEnd: '.4rem',
    },
    '& p': {
      fontSize: '12px',
      color: '#8C9099',
    },
  },
  content: {},
  docsContain: {
    gap: '8px',
    alignItems: 'center',
    '& p': {
      fontWeight: '600 !important',
      fontSize: '16px !important',
    },
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
    },
  },
  leaseDocs: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    gap: '16px',
    background: theme.palette.primary.white,
    '& $expandedAccordian': {
      borderBottom: '6px solid #EBEEF3',
    },
    '& $accordianTitle': {
      display: 'flex',
      '& p': {
        fontWeight: 600,
        fontSize: '14px',
      },
      '& > div': {
        margin: 0,
      },
    },
    '& $accordionDetails': {
      width: '100%',
      // padding: "24px",
    },
    '&:last-child': {
      '& $expandedAccordian': {
        borderBottom: 'none',
      },
    },
  },
  diplomatContainer: {
    padding: '16px',
    background: '#F9F6F2',
    border: '1px solid #D5D6D7',
  },
  expandedAccordian: {},
  accordianTitle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      // borderBottom: "1px solid #EBEEF3",
      paddingBottom: '12px',
    },
  },
  docsFlexContainer2: {
    display: 'flex',
    flexDirection: 'column',
    // gap: "12px",
  },
  actionBtn: {
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    padding: '8px',
    borderRadius: '0px',
    '&:last-child': {
      marginLeft: '16px',
    },
    '& img': {
      width: '20px !important',
      height: '20px !important',
    },
  },
  fileFlex2: {
    '& p': {
      fontSize: '14px',
    },
    '& img': {
      width: '40px',
      height: '40px',
    },
    '& button': {
      fontSize: '12px',
      fontWeight: 500,
    },
  },
  docsFlexContainer: {
    width: '100%',
    '& $fileFlex': {
      padding: '12px 0px',
      '& p': {
        fontSize: '14px',
        marginInlineStart: '1rem',
      },
      '& img': {
        width: '32px',
        height: '32px',
      },
      '& button': {
        fontSize: '14px',
        fontWeight: 500,
      },
    },
  },
  uploadDocBtn: {
    '&: hover': {
      color: theme.palette.primary.white,
      border: 'none',
      background: theme.palette.primary.adgmHover,
      '& img': {
        filter: 'invert(1)',
      },
    },
    '& p': {
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '21px',
    },
  },
  userName: {
    marginLeft: '16px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '8px',
    },
  },
  innerCard: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
    '& $label': {
      cursor: 'pointer',
    },
  },
  innerCardDocs: {
    padding: '12px',
  },
  innerCardBlock: {
    width: '100%',
  },
  occupantInnerCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: ' 24px 24px 8px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },
  occupantInnerCard2: {
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
    display: 'flex',
    flexDirection: 'column',
    padding: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },
  occupantDetailsBlock: {
    boxShadow: 'none !important',
  },
  [theme.breakpoints.up('sm')]: {
    CheckboxHolder: {
      '& label': {
        '& span': {
          fontSize: '18px',
        },
      },
    },
    CheckboxHolder2: {
      '& label': {
        '& span': {
          fontSize: '18px',
        },
      },
    },

    title: { fontSize: '18px' },
    innerCardGrid: {
      padding: '0px',
    },
    innerCardMultiple: {
      padding: '16px',
      border: '1px solid #CED1D6',
      borderRadius: '0px',
      background: theme.palette.primary.white,
    },
    titleHead: {
      '& h1': {
        // fontSize: "20px",

        fontSize: '18px',
        fontWeight: '600',
        lineHeight: '32px',
        letterSpacing: '0em',
      },
    },

    owaniTitleHead: {
      background: '#F8F8F8',
      color: '#342D3D',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      [theme.breakpoints.up('md')]: {
        borderBottom: '1px solid #CED1D6',
      },
      '& h1': {
        fontWeight: '600',
        fontSize: '21px',
        lineHeight: '32px',
        // '& span': {
        //   // color: theme.palette.primary.main,
        // },
        padding: '16px 24px',
      },

      '& $textGray': {
        color: theme.palette.primary.darkGrey,
        fontSize: '14px',
        alignSelf: 'flex-end',
      },
      '& $title1': {
        fontSize: '20px',
        fontWeight: '600',
      },
    },

    initiateserviceSect: {
      fontSize: '16px',
      '& p': {
        fontSize: '16px',
      },
      '& $Title': {
        fontSize: '20px',
      },
      '& $link': {
        fontSize: '14px',
      },
    },
    formControl: {
      gridTemplateColumns: '1fr 1fr',
      marginBottom: '20px',
    },
    formControlfullwidth: {
      marginBottom: '16px',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: '16px',
    },
    formControlfullwidth2: {
      // marginBottom: '16px',
      display: 'grid',
      gridTemplateColumns: '1fr',
      // gap: '16px',
    },
    largeButton: {
      height: '60px',
      minWidth: '228px',
      fontSize: '16px',
      borderRadius: '13.6111px',
      '& img': {
        marginRight: '8px',
        width: '17px',
      },
    },
    accTitleHead: {
      padding: '16px 24px 16px 24px',
      [theme.breakpoints.down('sm')]: {
        padding: '16px',
      },
      borderBottom: '1px solid #CED1D6',
      '& $heading': {
        fontSize: '21px',
        fontWeight: '600',
        lineHeight: '32px',
      },
      '& svg': {
        fontSize: '27px',
      },
    },
    initiateservicedtaile: {
      gridTemplateColumns: '61px auto',
      '& img': {
        display: 'block',
      },
    },
    innerCard: {
      padding: '0',
    },
    innerCardAppendix: {
      padding: '80px 56px',
      border: '1px dashed #828488',
      borderWidth: 'medium',
      background: theme.palette.primary.white,
      display: 'flex',
      justifyContent: 'center',
    },
    accordianFrame: { margin: '0 0 16px !important' },
    horizontalRadio: {
      '& span': {
        fontSize: '16px',
        // color: "#130F26 !important",
      },
    },
    premiseAddressField: {
      '& > p': {
        fontSize: '16px',
      },
      '& h6': {
        fontSize: '16px',
      },
    },
    appendixDetailItem: {
      '& p': {
        fontSize: '16px',
      },
      '& button': {
        fontSize: '14px',
      },
    },
    fileContainer: {
      '& p': {
        fontSize: '12px',
      },
      '& button': {
        fontSize: '14px',
      },
    },
    fileContainer2: {
      '& p': {
        fontSize: '14px',
      },
      '& button': {
        fontSize: '14px',
      },
    },
    premiseContent: {
      '& > div': {
        marginBottom: '2rem',
      },
    },
    occupantDetails: {
      '& $userName': {
        width: '200px',
      },
    },
  },
  [theme.breakpoints.down('sm')]: {
    titleHead: {
      flexWrap: 'wrap',
    },
    modal: {
      top: '0',
      left: '0',
      transform: 'translate(0)',
      maxWidth: '100%',
      borderRadius: '0',
      height: '100%',
      '& $Title': {
        fontSize: '16px',
        marginBottom: '0',
      },
      '& $crossIconimg': {
        display: 'none',
      },
      '& $modaltitlehead': {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '3px solid #EBEEF3',
        marginBottom: '20px',
        '& img': {
          marginRight: '13px',
          display: 'inline-block',
        },
      },
    },
    submitBtnholder: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      background: '#fff',
      padding: '16px',
      borderTop: '3px solid #EBEEF3',
      zIndex: '1021',
      '& button': {
        width: '100%',
        margin: '0 5px',
        height: '48px',
      },
    },

    occupantsGridsect: {
      '& h6': {
        fontSize: '12px',
      },
      '& p': {
        fontSize: '12px',
      },
    },
    occupantsReview: {
      '& h6': {
        fontSize: '12px',
      },
      '& p': {
        fontSize: '12px',
      },
    },

    paperCardFrame2: {
      marginBottom: '24px',
      borderRadius: '0px',
      bordrTop: '1px solid #EBEEF3',
    },
    infoPanel: {
      width: 'calc(100% - 30px)',
      margin: '0 auto 16px',
    },
    ownerListContainer: {
      '& $ownerListItem': {
        padding: '10px 0px 10px 10px',
        '& $avatar': {
          width: '40px',
          height: '40px',
          marginRight: '8px',
        },
        '& p': {
          fontSize: '14px',
        },
        '& $ownerCount': {
          fontSize: '14px',
        },
      },
    },
    premiseContainer: {
      gridTemplateColumns: '30% 110px',
      columnGap: '6px',
      '& > button': {
        height: '51px',
        fontSize: '12px',
        color: '#000',
        background: '#fff',
        border: '1px solid #0D2A3A',
        '&:hover': {
          textDecoration: 'none',
          background: 'rgba(0, 0, 0, 0.05)',
        },
      },
    },
    premiseContainer2: {
      gridTemplateColumns: 'auto 110px',
      columnGap: '6px',
      '& > button': {
        height: '51px',
        fontSize: '12px',
        color: '#000',
        background: '#fff',
        border: '1px solid #0D2A3A',
      },
    },
    infoMsg: {
      display: 'none',
    },
    addAppendixImg: {
      marginInlineEnd: '4px',
    },
    onwaniTitle: {
      fontSize: '14px',
    },
    onwaniText2: {
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '24px',
    },
    docsFlexContainer: {
      transition: 'all 1s ease',
      width: '100%',
      '& $addedBuyerFile': {
        marginBottom: '0px !important',
      },
      '& $fileFlex': {
        padding: '4px 0px',
        '& p': {
          fontSize: '12px',
        },
        '& img': {
          width: '20px',
          height: '20px',
        },
        '& button': {
          fontSize: '12px',
          fontWeight: 400,
          flexShrink: '0',
        },
      },
    },
    leaseDocs: {
      '& $accordianTitle': {
        // padding: "0px 16px",

        '& p': {
          marginTop: '0',
          fontSize: '12px',
        },
        '& img': {
          width: '16px',
          height: '18px',
        },
      },
    },

    uploadDocBtn: {
      '& p': {
        fontSize: '12px',
      },
    },

    outlinedBtn: {
      fontSize: '12px',
      borderRadius: '0px',
      '& img': {
        width: '10px',
      },
    },
    premiseContent: {
      display: 'flex',
      justifyContent: 'space-between',
      '& > div': {
        marginBottom: '.55rem',
      },
    },
    premiseUnitContainer: {
      '& h6, & p': {
        fontSize: '14px',
      },
    },
    onwaniContent: {
      borderBottom: '1px solid #EBEEF3',
      '& h6, & p': {
        fontSize: '14px',
      },
    },
    occupantDetails: {
      flexDirection: 'column',
      '& $ownerAvatarimg': {
        width: '40px',
        height: '40px',
      },
    },
    occupantDetail: {
      padding: '.75rem 0',
      '&:not(:last-of-type)': {
        paddingBottom: '16px',
        borderBottom: '1px solid #EBEEF3',
      },
      fontSize: '16px !important',
    },
  },
  [theme.breakpoints.down('xs')]: {
    innerCardGrid: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      rowGap: '10px',
      '& > div': {
        width: '100%',
      },
    },
    accordionDetails: {
      // padding: '16px',
    },
    accordionDetails2: {
      padding: '16px 16px 0px 16px',
    },
    attributeCheckbox: {
      '& .MuiFormControlLabel-label': {
        fontSize: '12px',
      },
    },
    checkboxContainer: {
      '& .MuiFormControlLabel-label': {
        fontSize: '16px',
      },
    },
  },
  outlinedBtn: {
    minWidth: '182px',
    fontSize: '1rem',
    borderRadius: '13.61px',
    borderColor: theme.palette.primary.adgmBlack,
    background: '#fff',
    '& img': {
      marginInlineEnd: '.5rem',
    },
  },
  outlinedBtn2: {
    minWidth: '182px',
    fontSize: '1rem',
    borderRadius: '0px',
    borderColor: theme.palette.primary.adgmBlack,
    background: '#EBEEF3',
    '& img': {
      marginInlineEnd: '.5rem',
    },
  },
  premiseUnitContainer: {
    '&:not(:last-of-type)': {
      borderBottom: '1px solid #EBEEF3',
      marginBottom: '8px',
      [theme.breakpoints.down('sm')]: {
        borderBottom: '8px solid #EBEEF3',
      },
    },
    '&:not(:first-of-type)': {
      paddingTop: '1rem',
    },
  },
  premiseInputContainer: {
    '& button': {
      marginInlineStart: '.7rem',
    },
  },
  textFieldPremise: {
    color: '#DF2C2C',
    '& .MuiOutlinedInput-root': {
      '&>fieldset': {
        border: '1px solid #DF2C2C !important',
      },
    },
  },
  textInput: {
    color: '#DF2C2C',
  },
  errorPremise: {
    marginTop: '4px',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '21px',
    color: '#DF2C2C',
  },
  premiseInput: {
    '& $label': {
      cursor: 'pointer',
    },
    // borderRadius: '0 !important',
    flex: '1',
    '& p': {
      fontSize: '14px !important',
    },
    '& .MuiInputBase-root': {
      height: '40px',
      [theme.breakpoints.up('sm')]: {
        width: '98%',
      },
      overflow: 'hidden',
      borderRadius: '0px !important',
    },
  },
  onwaniContainer: {
    // paddingBottom: "1.5rem",
    '&:not(:last-of-type)': {
      borderBottom: '1px solid #EBEEF3',
    },
  },
  onwaniContent: {
    padding: '1rem 0',
  },
  onwaniTitle: {
    color: '#484456',
  },
  onwaniTitle2: {
    color: '#484456',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '21px',
    [theme.breakpoints.down('sm')]: {
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
  onwaniText: {
    color: '#130F26',
    fontWeight: '500',
  },
  onwaniText2: {
    color: '#130F26',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '24px',
    [theme.breakpoints.down('sm')]: {
      fontWeight: '500',
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
  // style Occupant
  occupantDetailsContainer: {
    '&:not(:last-of-type)': {
      // borderBottom: '1px solid #CED1D6',
      paddingBottom: '16px',
      marginBottom: '16px',
      [theme.breakpoints.down('sm')]: {
        borderBottom: '3px solid #CED1D6',
      },
    },

    '& h6': {
      color: theme.palette.primary.adgmBlack,

      fontWeight: '600',
      [theme.breakpoints.down('sm')]: {
        fontWeight: '500',
        fontSize: '12px',
        lineHeight: '18px',
      },
    },
  },
  emptyOccupant: {
    padding: '12px',
    display: 'flex',
    gap: '8px',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '18px',
    alignItems: 'center',
    backgroundColor: '#FDF0ED',
    borderRadius: '0px',
    border: ' 1px solid #DF2C2C',
  },
  occupants: {
    '&::-webkit-scrollbar': {
      width: '1px',
    },
    maxHeight: '55vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      maxHeight: '100%',
    },
  },
  occupantsModal: {
    maxHeight: '55vh',
    overflowY: 'auto',
    padding: '0px 24px',
    '&::-webkit-scrollbar-track': {
      background: '#F8F8F8',
      borderRadius: '12px',
    },
    '&::-webkit-scrollbar': {
      width: '5px',
      borderRadius: '12px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CED1D6',
      borderRadius: '50rem',
    },
    [theme.breakpoints.down('sm')]: {
      height: '100%',
      maxHeight: '70vh',
    },
  },
  occupantContainer: {
    padding: '1rem 0',

    '&:not(:last-of-type)': {
      borderBottom: '1px solid #EBEEF3',
    },
  },
  font600: {
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '21px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '18px',
    },
  },
  occuContain: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
  },
  noBorder: {
    border: 'none !important',
  },
  occupantDetails: {
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
    margin: '0px !important',
    maxWidth: '100%',
    '& p': {
      color: '#484456',
    },
    '& h6': {
      color: theme.palette.primary.adgmBlack,
    },
    '& h6, & p': {
      fontSize: '14px',
      lineHeight: '21px',
      margin: '0',
    },
  },
  addMoreOccupant: {
    color: theme.palette.primary.errorRed,
    fontWeight: '500',
    fontSize: '20px',
    cursor: 'pointer',
  },
  disabledAddOccupant: {
    cursor: 'inherit',
    pointerEvents: 'none',
    color: theme.palette.secondary.disableLightGray,
  },
  viewAll: {
    color: theme.palette.primary.adgmGreen,
    cursor: 'pointer',
    borderTop: '1px solid #EBEEF3',
  },
  arrowRight: {
    marginInlineStart: '.55rem',
    display: 'inline-block',
    transform: `${theme.direction === 'rtl' && 'rotate(180deg)'}`,
  },
  propertyModalContainer: {
    maxHeight: '75vh',
    overflow: 'auto',
    borderTop: '1px solid #CED1D6',

    '& $occupantsGridsect': {
      padding: '1rem',
      '&:not(:last-of-type)': {
        borderBottom: '1px solid #EBEEF3',
      },
    },

    '&::-webkit-scrollbar-track': {
      background: '#F8F8F8',
      borderRadius: '12px',
    },
    '&::-webkit-scrollbar': {
      width: '5px',
      borderRadius: '12px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CED1D6',
      borderRadius: '50rem',
    },
  },
  headerWraperComponent: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      paddingBottom: '16px',
    },
  },
  // "@media (min-width: 768px)": {
  //   titleHead: {
  //     padding: "16px 24px",
  //     "& h1": {
  //       fontSize: "21px",
  //       fontWeight: "600",
  //       lineHeight: "32px",
  //       letterSpacing: "0em",
  //     },
  //   },
  // },
  // "@media (max-width: 767px)": {
  //   titleHead: {},
  // },
  occupantsFormContainer: {
    '& >div': {
      padding: '8px',
    },
  },

  occupantsInputsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    '& > :not(button)': {
      flex: 1,
    },
    '& > button': {
      marginTop: '28px',
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& > *': {
        with: '100%',
      },
      '& > button': {
        marginTop: 0,
      },
    },
  },

  addOtherOccupantBtn: {
    marginTop: '16px',
  },
  formDivider: {
    margin: '16px 0px',
  },
  [theme.breakpoints.down('sm')]: {
    diploamtRadio: {
      minWidth: '100%',
    },
    titleHead: {
      flexWrap: 'wrap',
      padding: '16px 0px',
    },
    occupantDetail: {
      width: '100%',
      '&:not(:last-of-type)': {
        borderBottom: '1px solid #EBEEF3',
      },
    },
    lessorGrid: {
      '&:not(:last-of-type)': {
        borderBottom: '1px solid #EBEEF3',
      },
    },
  },
  rentSpan: {},
  contractLength: {
    '& div': {
      color: '#6C7281',
      background: '#EAEBEB',
      borderRadius: '0px',
      fontSize: '16px',
      [theme.breakpoints.down('md')]: {
        fontSize: '12px',
      },
    },
    '& input': {
      width: '10px',
    },
    '& $rentSpan': {
      paddingLeft: '8px',
      borderLeft: '1px solid #CED1D6',
      '& p': {
        fontSize: '16px',
        [theme.breakpoints.down('md')]: {
          fontSize: '12px',
        },
      },
    },
  },
  infoPanelAlert: {
    width: '100%',
  },
  infoSectionAlert: {
    display: 'inline-flex',
    flexDirection: 'column',
    gap: '8px',
  },
  bold: {
    fontWeight: '600',
  },
  errorAttribute: {
    fontSize: '14px',
    color: theme.palette.primary.errorRed,
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
  },
});

export default styles;
